// toIATA — pure conversion of a FlightAware airport object to its IATA code.
//
// Extracted verbatim from `FlightLookup.js` (module-level `toIATA` helper) as
// part of the behavior-preserving refactor (issue #240). Prefers `code_iata`,
// falls back to `code`, uppercases, and strips a leading ICAO `K` prefix.
//
// Totality preserved exactly: returns `''` for a missing airport object and for
// an object with no usable code field, matching the source.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Converts a FlightAware airport object to its IATA code.
 *
 * @param {Object|null|undefined} ap - Airport object (may carry `code_iata`/`code`).
 * @returns {string} The uppercase IATA code with any leading `K` stripped, or `''`.
 */
export function toIATA(ap) {
  if (!ap) return '';
  return String(ap.code_iata || ap.code || '').toUpperCase().replace(/^K/, '');
}

export default toIATA;
